/* eslint-disable react/prop-types */
import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core'
import Cookies from 'js-cookie'
import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { rules, schema } from '@config/yup.schema'
import { useSnackbar } from 'notistack'
import { resellerApiWithToken } from '@api/baseApi'
import FormComponent from './FormComponent'
import { postApi } from './api'

const resolver = yupResolver(
  schema({
    // bank_name: rules.stringRequired,
    // account_name: rules.stringRequired,
    // bank_account: rules.stringRequired,
    amount: rules.stringRequired,
    bank: rules.mixed,
  }),
)

const defaultValues = {
  // bank_name: '',
  // account_name: '',
  // bank_account: '',
  amount: '',
  bank: null,
}

const FormDialog = ({ open, onClose, fetchWithdraw }) => {
  const scope = Cookies.get('scope')
  const methods = useForm({
    defaultValues,
    resolver,
  })

  const [loading, setLoading] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [summary, setSummary] = useState({})

  let path

  if (scope === 'reseller') {
    path = '/resellers/withdraws'
  } else {
    path = '/affiliates/withdraws'
  }

  let summaryPath

  if (scope === 'reseller') {
    summaryPath = '/resellers/summaries/'
  } else {
    summaryPath = '/affiliates/summaries/'
  }

  const getSummaries = async () => {
    try {
      const {
        status,
        data: { data },
      } = await resellerApiWithToken.get(summaryPath)
      if (status === 200) {
        setSummary(data)
      }
    } catch (error) {
      setSummary({})
    }
  }

  useEffect(() => {
    getSummaries()
  }, [])
  const onSubmit = async (value) => {
    try {
      setLoading(true)

      // eslint-disable-next-line no-param-reassign
      if (value.bank) value.bank_account_id = value.bank?.id

      const { status, data } = await postApi(value, path)
      if (Array.isArray(data?.data)) {
        setLoading(false)
        enqueueSnackbar(data?.data?.[0], { variant: 'error' })
      } else if (status === 200) {
        setLoading(false)
        enqueueSnackbar('Berhasil menambah permintaan withdraw', {
          variant: 'success',
        })
        fetchWithdraw()
        getSummaries()
        onClose()
      } else {
        setLoading(false)
        enqueueSnackbar(
          'Maaf, terjadi kesalahan saat menambah permintaan withdraw',
          { variant: 'error' },
        )
      }
    } catch (error) {
      const response = error?.response?.data
      if (Array.isArray(response?.data)) {
        setLoading(false)

        enqueueSnackbar(response?.data?.[0]?.mess, { variant: 'error' })
      } else {
        setLoading(false)
        enqueueSnackbar(
          response || 'Maaf, terjadi kesalahan saat menambah permintaan withdraw',
          { variant: 'error' },
        )
      }
    }
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <DialogTitle>Tambah Permintaan Withdraw</DialogTitle>
          <DialogContent>
            <div style={{ display: 'block' }}>
              <Typography
                style={{
                  fontSize: '12px',
                  marginBottom: '4px',
                  color: 'rgba(0, 0, 0, 0.54)',
                }}
              >
                Saldo Saai Ini
              </Typography>
              <Typography style={{ fontSize: 24 }}>
                {summary?.formatted_balance}
              </Typography>
            </div>
            <FormComponent
              disabled={loading}
              scope={scope}
              defaultValues={defaultValues}
              max={parseInt(summary?.balance, 10) - 2775 || 0}
              getValues={methods.getValues}
            />
          </DialogContent>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
            >
              Simpan
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={onClose}
              disabled={loading}
            >
              Batal
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  )
}

export default FormDialog
